import { useEffect } from 'react';
let targetElement;
function getElement() {
    if (!targetElement) {
        targetElement = document.createElement('div');
    }
    return targetElement;
}
export function useCustomEventListener(eventName, eventHandler, deps) {
    let element;
    useEffect(() => {
        element = element || getElement();
        const handleEvent = (event) => {
            const data = event.detail;
            if (data) {
                eventHandler(data);
            }
            else {
                eventHandler();
            }
        };
        element.addEventListener(eventName, handleEvent, false);
        return () => {
            element?.removeEventListener(eventName, handleEvent, false);
        };
    }, deps);
    return (el) => {
        element = el;
    };
}
export function emitCustomEvent(eventName, data) {
    const element = getElement();
    const event = new CustomEvent(eventName, { detail: data });
    element.dispatchEvent(event);
}
export function newCustomEventEmitter() {
    let element;
    function setElement(el) {
        element = el;
    }
    setElement.emit = function (eventName, data) {
        const event = new CustomEvent(eventName, { bubbles: true, detail: data });
        element?.dispatchEvent(event);
    };
    return setElement;
}
